import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Flex, Image } from 'ui/acro'
import styledComponents from 'styled-components'
import { css } from '@styled-system/css'
import {
  SearchCardSubitle,
  SearchCardTitle
} from '../common/SearchCardTextStyles'

const PlaylistImage = styledComponents(Image)`
  ${css({
    objectFit: 'cover',
    aspectRatio: '1/1'
  })}
`

const PlaylistResultCard = forwardRef(
  (
    {
      carouselItem,
      title,
      htmlId,
      author,
      uuid,
      classesCount,
      thumbnailImage,
      followerCount,
      altText
    },
    ref
  ) => {
    return (
      <Flex
        id={htmlId}
        as='a'
        flexDirection='column'
        className={carouselItem ? 'swiper-slide unstyled' : 'unstyled'}
        href={`/playlists/${uuid}`}
      >
        <PlaylistImage
          src={
            thumbnailImage !== null
              ? thumbnailImage
              : 'https://alomoves.s3.amazonaws.com/manual_uploads/shared/search/placeholder-cards/square-card.jpg'
          }
          altText={altText}
        />
        {title && (
          <SearchCardTitle className='playlist-title' mt='0.8em'>
            {title}
          </SearchCardTitle>
        )}
        {author && (
          <SearchCardSubitle mt='0.2em'>
            By: {author === 'Admin User' ? `ALO Wellness Club` : `${author}`}
            <br></br>
            {classesCount} {classesCount !== 1 ? 'classes' : 'class'} •{' '}
            {followerCount} {followerCount !== 1 ? 'followers' : 'follower'}
          </SearchCardSubitle>
        )}
      </Flex>
    )
  }
)

PlaylistResultCard.propTypes = {
  title: PropTypes.string.isRequired,
  htmlId: PropTypes.any,
  thumbnailImage: PropTypes.string,
  uuid: PropTypes.string.isRequired,
  author: PropTypes.string,
  classesCount: PropTypes.number,
  followerCount: PropTypes.number,
  altText: PropTypes.string
}

export default PlaylistResultCard
